export const CATEGORY_MAP = {
  behaviour_issue: {
    label: "Behaviour Issue",
    subs: [
      { key: "rude_behavior", label: "Rude Behavior" },
      { key: "abusive_language", label: "Use of Abusive Language" },
    ],
  },
  
  delivery_issue: {
    label: "Delivery Issue",
    subs: [
      { key: "delay_delivery", label: "Delay Delivery" },
      { key: "delivery_boy_issue", label: "Delivery Boy Issue" },
      { key: "rto_order_concern", label: "RTO Order Concern" },
      { key: "india_post", label: "India Post" },
      { key: "online_order", label: "Online Order" },
      { key: "wants_future_delivery", label: "Wants Future Delivery" },
    ],
  },
  wrong_product_delivered: {
    label: "Wrong Product Delivered Issue",
    subs: [
      { key: "incorrect_product", label: "Incorrect Product Delivered" },
      { key: "missing_product", label: "Missing Product" },
      { key: "other_product_delivered", label: "Other Product Delivered" },
    ],
  },
  product_complaint: {
    label: "Product Complaint",
    subs: [
      { key: "medicine_not_effective", label: "Medicine Not Effective" },
      { key: "product_quality_issue", label: "Product Quality Issue" },
      { key: "quantity_issue", label: "Quantity Issue" },
      { key: "manufacturing_issue", label: "Manufacturing Issue" },
      // { key: "wrong_product", label: "Wrong Product" },
      // { key: "missing_product", label: "Missing Product" },
    ],
  },
  payment_refund_request: {
    label: "Payment Refund Request",
    subs: [
      { key: "extra_payment_received", label: "Extra Payment Received" },
      { key: "refund_not_received", label: "Refund Not Received" },
      { key: "payment_failed", label: "Payment Failed" },
    ],
  },
  need_to_talk: { label: "Need to Talk", subs: [] },
  number_block_request: {
    label: "Number Block Request",
    subs: [
      {
        key: "back_to_back_calls",
        label: "Customer Receiving Back-to-Back Calls",
      },
    ],
  },
  wrong_punch_or_info: {
    label: "Wrong Punch / Wrong Medicine Info",
    subs: [
      { key: "wrong_punch_miss_punch", label: "Wrong Punch or Miss Punch" },

      { key: "incomplete_incorrect_information", label: "Incomplete or Incorrect Information" },
      {
        key: "price_issue",
        label: "Price Issue / Price Manipulation",
      },
      {
        key: "fake_order_fake_commitment",
        label: "Fake Order or Fake commitment",
      },
      {
        key: "return_refund_issue",
        label: "Return or Refund Issue",
      },
    ],
  },
  technical_glitch: {
    label: "Technical Glitch",
    subs: [
      {
        key: "payment_done_but_order_missing",
        label: "Payment Done But Order Missing",
      },
      {
        key: "after_delivery_free_medicine",
        label: "After Delivery Free Medicine",
      },
    ],
  },
  other: { label: "Other", subs: [{ key: "other", label: "Other" }] },
};